up.compiler('[go-back]', (element) => {
  element.addEventListener('click', () => history.back())
})
